import { FormInputTypes } from '../../../shareable/types';
import { getDefaultText, getImageDefault } from '../../helpers';

export default {
    name: 'Header',
    inputs: {
        backgroundColor: {
            label: 'Couleur de fond',
            type: FormInputTypes.COLOR,
            value: '#FFFFFF'
        },
        backgroundImage: {
            label: 'Image de fond',
            type: FormInputTypes.IMAGE,
            value: null
        },
    },
    blocks: {
        title: getDefaultText("Titre", "Jeu concours du JJ/MM au JJ/MM", 16, "#53839D"),
        logo: getImageDefault(),
    }
};